import * as Icons from "lucide-react";
import { motion } from "framer-motion";
import { useSettings } from "@/context/SettingsContext";
import { Reveal } from "@/components/Reveal";

export const WhyUs = () => {
  const settings = useSettings();
  const blocks = settings.why_us || [];
  return (
    <section
      id="waarom"
      data-testid="why-us-section"
      className="py-24 md:py-32 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-2xl mb-14">
          <span className="text-[#FF1A1A] text-sm font-semibold tracking-[0.25em] uppercase">
            Waarom Klusbedrijf Pruijn
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white mt-5 leading-tight">
            Gebouwd op vertrouwen.
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {blocks.map((b, i) => {
            const Icon = Icons[b.icon] || Icons.Check;
            return (
              <motion.div
                key={b.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6, delay: i * 0.1, ease: "easeOut" }}
                data-testid={`why-us-block-${i}`}
                className="bg-[#111111] p-9 md:p-10 border-l-4 border-l-[#FF1A1A] flex flex-col gap-4 hover:bg-[#161616] transition-colors duration-300"
              >
                <Icon className="text-[#FF1A1A]" size={34} strokeWidth={1.4} />
                <h3 className="font-heading text-xl md:text-2xl font-semibold text-white">
                  {b.title}
                </h3>
                <p className="text-white/55 font-light leading-relaxed">
                  {b.text}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
